import React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { IOrganisationDetailsHomePresenter } from "../../presenter/OrganisationDetailsHomePresenter";
import { Button, Divider, Layout, List, Typography } from "antd";
import Text from "antd/lib/typography/Text";
import InstitutionDetailsSidebar from "../components/InstitutionDetailsSidebar";
const { Sider } = Layout;
export interface Props extends PageProps {}

export interface State extends IOrganisationDetailsHomePresenter {}

export default class OrganisationDetailsHomePage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      showCategories,
      translate,
      organisation,
      institutionDetails,
      user,
      caseLawDocumentTypes,
      caseDecisionTypes,
      legalViewTypes
    } = this.state;

    return (
      <Page {...this.props}>
        {user && !user.isAdmin() ? (
          <Layout>
            <Sider
              className={"content-container dashboard-sider  "}
              breakpoint="xl"
              collapsedWidth="0"
              collapsible
              width={"22%"}
              style={{ height: "100vh" }}
            >
              <div className={"dashboard-sider-project-title-wrapper"}>
                <Text className={"dashboard-sider-project-title"}>
                  {organisation.name}
                </Text>
              </div>
              <InstitutionDetailsSidebar
                translate={translate}
                institutionDetails={institutionDetails}
              />

              {caseLawDocumentTypes.map((item) => {
                return (
                  <List
                    header={
                      <Typography className={"dashboard-content-title"}>
                        {item.name}
                      </Typography>
                    }
                    size="large"
                    locale={{
                      emptyText: translate("data_grid.empty_text")
                    }}
                    dataSource={item.organisationIndexCategories || []}
                    renderItem={(caseLawDocumentType) => (
                      <div>
                        {" "}
                        <Button
                          onClick={() => showCategories(caseLawDocumentType.id)}
                          size="middle"
                          type="link"
                        >
                          {caseLawDocumentType.name}
                        </Button>
                      </div>
                    )}
                  />
                );
              })}
              <Divider />

              {caseDecisionTypes.map((item) => {
                return (
                  <List
                    header={
                      <Typography className={"dashboard-content-title"}>
                        {item.name}
                      </Typography>
                    }
                    size="large"
                    locale={{
                      emptyText: translate("data_grid.empty_text")
                    }}
                    dataSource={item.organisationIndexCategories || []}
                    renderItem={(caseDecisionType) => {
                      return (
                        <div>
                          <Button
                            onClick={() => showCategories(caseDecisionType.id)}
                            size="middle"
                            type="link"
                          >
                            {caseDecisionType.name}
                          </Button>
                        </div>
                      );
                    }}
                  />
                );
              })}
              <Divider />
              {legalViewTypes.map((item) => {
                return (
                  <List
                    header={
                      <Typography className={"dashboard-content-title"}>
                        {item.name}
                      </Typography>
                    }
                    size="large"
                    locale={{
                      emptyText: translate("data_grid.empty_text")
                    }}
                    dataSource={item.organisationIndexCategories || []}
                    renderItem={(caseDecisionType) => {
                      return (
                        <div>
                          <Button
                            onClick={() => showCategories(caseDecisionType.id)}
                            size="middle"
                            type="link"
                          >
                            {caseDecisionType.name}
                          </Button>
                        </div>
                      );
                    }}
                  />
                );
              })}
            </Sider>
          </Layout>
        ) : (
          <div></div>
        )}
      </Page>
    );
  }
}
